export default {
  namespaced: true,
  state: {
    _platform: "BROWSER",
    _language: "en",
    _locale: "en-US",
    _size: null,
    _initial_width: null,
    _initial_height: null,
    _scroll: {}
  },
  getters: {
    platform: state => state._platform,
    language: state => state._language,
    locale: state => state._locale,
    size: state => state._size < 1024 ? 'sm' : 'lg',
    initialWidth: state => state._initial_width,
    initialHeight: state => state._initial_height,
    scroll: state => state._scroll
  },
  actions: {},
  mutations: {
    SET_PLATFORM(state, payload) {
      state._platform = payload;
    },
    SET_LANGUAGE(state, payload) {
      state._language = payload;
    },
    SET_LOCALE(state, payload) {
      state._locale = payload;
    },
    SET_SIZE(state, payload) {
      state._size = payload;
    },
    SET_INITIAL_WIDTH(state, payload) {
      state._initial_width = payload;
    },
    SET_INITIAL_HEIGHT(state, payload) {
      state._initial_height = payload;
    },
    SET_PAGE_SCROLL(state, {pageName, scroll}) {
      state._scroll[pageName] = scroll;
    }
  }
};

